import { cva } from 'class-variance-authority';

export const containerVariants = cva([''], {
  variants: {
    type: {
      default: ['flex'],
      main: ['min-h-[calc(100vh-120px)]'],
      mainNoFooter: ['min-h-[calc(100vh-60px)]'],
    },
    hasPadding: {
      true: ['px-6 md:px-8 lg:px-16'],
      false: ['px-0'],
    },
  },
  defaultVariants: {
    type: 'default',
  },
});
